import { ApplicationConfig, importProvidersFrom, inject, provideAppInitializer } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { provideClientHydration } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';

import { routes } from './app.routes';
import { JwtInterceptor } from './interceptors/jwt.interceptor';
import { LanguageService } from './services/language.service';
import { CapacitorRuntimeService } from './core/platform/capacitor-runtime.service';
import { MobilePushService } from './core/notifications/mobile-push.service';

/**
 * Initialize translations before app loads
 */
function initializeTranslations(languageService: LanguageService) {
  return () => languageService.initializeTranslations();
}

function initializeCapacitorRuntime(capacitorRuntimeService: CapacitorRuntimeService) {
  return () => capacitorRuntimeService.initialize();
}

function initializeMobilePush(mobilePushService: MobilePushService) {
  return () => mobilePushService.initialize().catch((error) => {
    console.error('Mobile push initialization failed', error);
  });
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideClientHydration(),
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true
    },
    importProvidersFrom(
      TranslateModule.forRoot({
        fallbackLang: 'pl'
      })
    ),
    provideAppInitializer(() => {
        const initializerFn = (initializeTranslations)(inject(LanguageService));
        return initializerFn();
      }),
    provideAppInitializer(() => {
        const initializerFn = (initializeCapacitorRuntime)(inject(CapacitorRuntimeService));
        return initializerFn();
      }),
    provideAppInitializer(() => {
        const initializerFn = (initializeMobilePush)(inject(MobilePushService));
        return initializerFn();
      })
  ]
};
